export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PanoWhiteboard.vue?vue&type=template&id=7406134f&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/whiteboard/PanoWhiteboard.vue?vue&type=template&id=7406134f&scoped=true&
// module id = null
// module chunks = 